import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { LanguageSwitcher } from '../components/LanguageSwitcher'

export function NotFoundPage() {
  const { t } = useTranslation(['common'])

  return (
    <>
      {/* Fixed Language Switcher */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageSwitcher />
      </div>

      <div className="home-container" style={{ minHeight: '100vh' }}>
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="max-w-md w-full">
            {/* Standalone Logo */}
            <div className="flex justify-center mb-8">
              <img src="/images/logo.png" alt="Logo" />
            </div>

            <div className="card-neobrutalism text-center">
              <h1 className="text-6xl font-black text-neobrutalism-text mb-4">404</h1>
              <h2 className="text-2xl font-bold text-neobrutalism-text mb-6">
                {t('notFound.title')}
              </h2>
              <p className="text-lg mb-8">
                {t('notFound.description')}
              </p>
              <Link 
                to="/" 
                className="btn-neobrutalism bg-neobrutalism-accent inline-block text-xs sm:text-base py-2 sm:py-3 px-2 sm:px-4"
              >
                {t('notFound.backHome')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
} 